import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import {
  Person as UserIcon,
  CalendarMonth as CalenderIcon,
  Place as Location,
  Comment,
} from "@mui/icons-material";

import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import Btn from "components/Custom/Btn";
import SkeletonBox from "components/Custom/SkeletonBox";

import { LABELS, SUCCESS, WARNINGS } from "common/lables";
import { COLORS } from "common/colors";
import { CRM_LEAD_STATUS, FORMATS, NOTIFY } from "common/config";
import { COMMON_JS } from "common/scripts";

import { CUSTOMER_APIs } from "apihandlers/customer";
import { USER_APIs } from "apihandlers/user";
import { DateFunctions } from "common/datefunctions";

import { CRM_APIs } from "apihandlers/crm";
import StatusButtons from "../StatusButtons";

import jsPDF from "jspdf";
import Comments from "../Comments";

const InterviewQuestions = (props: any) => {
  const {
    data,
    areas,
    onClose,
    selectedRow,
    isButtonDisabled,
    remarksList,
    getCrmRemarks,
    remarksLoading,
    setRemarksLoading,
  } = props;
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [toUsers, setToUsers] = useState([]);
  const [byUsers, setByUsers] = useState([]); // todo: get only marketing users
  const [assignedInfo, setAssignedInfo] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [questionList, setQuestionList] = useState([]);
  const [completed, setCompleted] = useState(false);
  const [completedAnswer, setCompletedAnswer] = useState<any>([]);

  // if (completed) {
  //   setCompletedAnswer(() => {
  //     const data = JSON.parse(completedAnswer);
  //     return data.map(JSON.parse(data));
  //   });
  // }

  useEffect(() => {
    if (loading) {
      loadInitData();
    }
  }, [loading]);

  const loadInitData = async () => {
    console.log("loadInitData");
    try {
      if (selectedRow.crmLeadStatus === CRM_LEAD_STATUS.INTERVIEW_PROCESS) {
        const args = {
          isExclusive: selectedRow.isExclusive,
        };
        const res: any = await CUSTOMER_APIs.getCrmInterviews(args);
        console.log("loadInitData: res1:", res);
        if (res.status === 200) {
          setQuestionList(res.response.records);
          setLoading(false);
        }
      } else {
        const args = {
          leadId: selectedRow.id,
        };
        const res: any = await CRM_APIs.getCrmLeadInterviews(args);
        console.log("loadInitData: res2:", res);
        if (res.status === 200) {
          setCompletedAnswer(JSON.parse(res.response.records[0].question));
          setCompleted(true);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("loadInitData: error:", error);
    }
  };

  const saveRecord = async () => {
    console.log("questionList", questionList);
    try {
      let interviewQuestion = [];

      for (let i = 0; i < questionList.length; i++) {
        const item = (
          document.getElementById(questionList[i].id) as HTMLInputElement
        ).value.trim();
        interviewQuestion.push({
          id: questionList[i].id,
          value: item,
          question: questionList[i].question,
        });
      }

      const args = {
        crmLeadStatus: CRM_LEAD_STATUS.INTERVIEW_QUESTIONS,
        activeStatus: "true",
        id: -1,
        leadId: selectedRow.id,
        question: interviewQuestion,
        // id: assignedInfo.id || -1,
        // assignedToId: toUsersRef.current.selectedValue.id,
        // assignedById: byUsersRef.current.selectedValue.id,
        // assignedDate: (
        //   document.getElementById("assignedDate") as HTMLInputElement
        // ).value,
        // areaId: areasRef.current.selectedValue.id,
        // comments: (
        //   document.getElementById("assignComments") as HTMLInputElement
        // ).value,
      };
      console.log("interviewQuestion", interviewQuestion);
      // let errors = [];
      // if (!args.assignedToId) {
      //   errors.push({
      //     id: "toUsersRef",
      //     msg:
      //       "<span class='bold'>" +
      //       LABELS.ASSIGNED_TO +
      //       "</span> " +
      //       WARNINGS.IS_A_REQUIRED_FIELD,
      //   });
      // }
      // if (!args.assignedById) {
      //   errors.push({
      //     id: "byUsersRef",
      //     msg:
      //       "<span class='bold'>" +
      //       LABELS.ASSIGNED_BY +
      //       "</span> " +
      //       WARNINGS.IS_A_REQUIRED_FIELD,
      //   });
      // }
      // if (!args.areaId) {
      //   errors.push({
      //     id: "areasRef",
      //     msg:
      //       "<span class='bold'>" +
      //       LABELS.AREA +
      //       "</span> " +
      //       WARNINGS.IS_A_REQUIRED_FIELD,
      //   });
      // }
      // if (!args.assignedDate) {
      //   errors.push({
      //     id: "assignedDate",
      //     msg:
      //       "<span class='bold'>" +
      //       LABELS.ASSIGNED_DATE +
      //       "</span> " +
      //       WARNINGS.IS_A_REQUIRED_FIELD,
      //   });
      // }

      // if (!args.comments) {
      //   errors.push({
      //     id: "assignComments",
      //     msg:
      //       "<span class='bold'>" +
      //       LABELS.COMMENTS +
      //       "</span> " +
      //       WARNINGS.IS_A_REQUIRED_FIELD,
      //   });
      // }

      // setMandatoryResults(errors);
      // if (errors.length > 0) {
      //   COMMON_JS.showNotify(
      //     props,
      //     NOTIFY.WARNING,
      //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
      //   );
      //   return;
      // }

      // if (
      //   !args.assignedToId ||
      //   !args.assignedById ||
      //   !args.assignedDate ||
      //   !args.areaId ||
      //   !args.comments
      // ) {
      //   COMMON_JS.showNotify(
      //     props,
      //     NOTIFY.WARNING,
      //     WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      //   );
      //   return;
      // }
      setIsSubmit(true);
      console.log("args", args);
      // return;
      const res: any = await CRM_APIs.manageCrmLeadInterview(args);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        onClose(true);
        // getCrmLeadAssigned();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Error: " + res.error);
      }
      setIsSubmit(false);
      console.log("saveRecord: ", args, res);
    } catch (error) {
      setIsSubmit(false);
      console.log("saveRecord: error:", error);
    }
  };
  console.log("selected row", completedAnswer);

  return (
    <div>
      <fieldset className="formSection" style={{ padding: "2rem" }}>
        {loading === false ? (
          <div>
            {completed === true ? (
              <>
                <div className="formGroup">
                  {completedAnswer &&
                    completedAnswer.map((interviewQuestions, key) => {
                      return (
                        <div>
                          <div className="formGroup">
                            <div className="formGroup width30">
                              <TxtRow
                                id={interviewQuestions.id}
                                label={
                                  key + 1 + " " + interviewQuestions.question
                                }
                                placeholder={
                                  interviewQuestions.value
                                    ? interviewQuestions.value
                                    : " "
                                }
                                disabled={true}
                              />
                            </div>
                          </div>
                          {/* <StatusButtons
                          isButtonDisabled={isButtonDisabled}
                          selectedRow={selectedRow}
                        /> */}
                        </div>
                      );
                    })}
                </div>
              </>
            ) : (
              <div>
                <div className="formGroup">
                  {questionList.map((interviewQuestions, key) => {
                    return (
                      <div className="formGroup">
                        <div className="formGroup width30">
                          <TxtRow
                            id={interviewQuestions.id}
                            label={key + 1 + " " + interviewQuestions.question}
                            placeholder={"Answer"}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="formGroup submitBtnWrapper width30">
                  <div className="flexbtnjustify">
                    <Btn
                      text={LABELS.SAVE}
                      loading={isSubmit}
                      bgColor={COLORS.SAVE_GREEN}
                      onClick={saveRecord}
                      disabled={isButtonDisabled}
                    />
                  </div>
                </div>
                {/* <StatusButtons
                  isButtonDisabled={isButtonDisabled}
                  selectedRow={selectedRow}
                  onClose={onClose}
                /> */}
              </div>
            )}
            {/* <div className="formGroup">
              {questionList.map((interviewQuestions, key) => {
                return (
                  <div className="formGroup">
                    <div className="formGroup width30">
                      <TxtRow
                        id={interviewQuestions.id}
                        label={key + 1 + " " + interviewQuestions.question}
                        placeholder={"Answer"}
                      />
                    </div>
                  </div>
                );
              })}
            </div> */}
          </div>
        ) : (
          <div>
            <div className="formGroup">
              <SkeletonBox
                height={170}
                width={"30%"}
                style={{ marginBottom: 15 }}
              />
            </div>
            <div className="formGroup submitBtnWrapper width30">
              <SkeletonBox
                height={30}
                width={"30%"}
                style={{ marginBottom: 15 }}
              />
            </div>
          </div>
        )}
      </fieldset>
      <Comments
        selectedRow={selectedRow}
        isButtonDisabled={isButtonDisabled}
        remarksList={remarksList}
        getCrmRemarks={getCrmRemarks}
        remarksLoading={remarksLoading}
        setRemarksLoading={setRemarksLoading}
      />
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default withSnackbar(InterviewQuestions);
